import { render, staticRenderFns } from "./CallCentreInstallationData.vue?vue&type=template&id=78997b55&scoped=true"
import script from "./CallCentreInstallationData.vue?vue&type=script&lang=ts"
export * from "./CallCentreInstallationData.vue?vue&type=script&lang=ts"
import style0 from "./CallCentreInstallationData.vue?vue&type=style&index=0&id=78997b55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78997b55",
  null
  
)

export default component.exports